import { render, staticRenderFns } from "./Media.vue?vue&type=template&id=77010af7&scoped=true"
import script from "./Media.vue?vue&type=script&lang=ts"
export * from "./Media.vue?vue&type=script&lang=ts"
import style0 from "./Media.vue?vue&type=style&index=0&id=77010af7&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77010af7",
  null
  
)

export default component.exports